import * as React from "react";
const SendIcon = (props) => (
  <svg
    width={31}
    height={31}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_80_11)">
      <path
        d="M2.17186 9.72903L11.2153 25.1419C11.4103 25.4777 11.7479 25.7033 12.1336 25.7551C12.5192 25.8069 12.8991 25.6816 13.1877 25.4073L15.4207 23.2387C15.4207 23.2387 19.6319 24.5768 20.4317 24.6711C20.5865 24.6937 20.6404 24.6654 20.7353 24.6341C20.8683 24.5902 20.9982 24.5052 21.0871 24.3917C21.2427 24.1929 21.2941 23.9338 21.2158 23.6964L19.5524 18.6536C19.5274 18.546 19.4835 18.4447 19.392 18.359C19.392 18.359 19.3763 18.3432 19.3636 18.3368C19.3195 18.2987 19.2753 18.2606 19.2217 18.2257L7.31758 11.5381L21.1422 16.8972C21.2558 16.9545 21.3949 16.9929 21.5277 16.9806C21.7459 16.9718 21.9518 16.8618 22.0852 16.6914L25.1963 13.833C25.5389 13.4988 25.6637 13.0154 25.5324 12.5533C25.3946 12.1038 25.0194 11.7643 24.5485 11.6774L3.49009 7.85159C2.99705 7.7615 2.51575 7.96239 2.22037 8.37572C1.93448 8.78593 1.91704 9.30765 2.16237 9.73216L2.17186 9.72903Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip0_80_11">
        <rect
          width={24}
          height={24}
          fill="white"
          transform="matrix(-0.949668 0.313259 0.313259 0.949668 22.792 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SendIcon;
